//import {MathUtil, SpringSystem} from 'rebound';
import React from 'react';
import {Scrollbars} from "react-custom-scrollbars";

const styles = theme => ({});

class ControllableScrollbar extends React.Component {

    getScrollLeft = () => this.refs.scrollbars.getScrollLeft();
    getScrollWidth = () => this.refs.scrollbars.getScrollWidth();
    getScrollTop = () => this.refs.scrollbars.getScrollTop();
    getScrollHeight = () => this.refs.scrollbars.getScrollHeight();
    getHeight = () => this.refs.scrollbars.getHeight();
    getWidth = () => this.refs.scrollbars.getWidth();

    scrollLeft = (left) => {
        const {scrollbars} = this.refs;
        scrollbars.scrollLeft(left);
    };

    scrollTop = (top) => {
        const {scrollbars} = this.refs;
        scrollbars.scrollTop(top);
    };

    render() {
        return (
            <Scrollbars
                {...this.props}
                ref="scrollbars"/>
        );
    }
}

export default ControllableScrollbar;